import { Typography, Menu, MenuItem, Divider, IconButton } from '@mui/material';
import React, { useRef, useState } from 'react';
import Iconify from 'src/components/iconify';
import { useTranslation } from 'react-i18next';

const MenuActionsItem = ({
    item,
    isAdmin,
    open,
    anchorEl,
    onClose,
    dataRef,
    setVisibleApprove,
    setVisibleReject,
    setVisibleOpenChecking,
    setVisibleOpenAdminTakeDevice,
    setVisibleOpenAdminPutDevice,
}) => {
    const { t } = useTranslation();

    // Admin chưa lấy thiết bị ra (admin_checking_date == null)
    const hasNotTakenDevice = item?.admin_checking_date == null;

    // Disable xác nhận/từ chối nếu chưa lấy thiết bị hoặc status không phù hợp
    const disabledApproveReject = ['1', '2', '3', '4'].includes(item.status) || hasNotTakenDevice;

    // Disable từ chối nếu status không phù hợp
    const disabledReject = ['1', '2', '3', '4'].includes(item.status) || hasNotTakenDevice;

    // Disable lấy thiết bị nếu đã lấy rồi hoặc status không phù hợp
    const disabledTakeDevice = ['2', '4'].includes(item.status) || !hasNotTakenDevice;

    // Disable bỏ thiết bị vào nếu chưa lấy ra hoặc đã từ chối (status 4)
    const disabledPutDevice = hasNotTakenDevice || item.status === '4' || item.status != '1';

    const handleClick = (fn, e) => {
        dataRef.current = item;
        fn(true);
        onClose(e);
    };

    return (
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
            {isAdmin && [
                // Bước 1: Lấy thiết bị ra
                <MenuItem
                    key="take-device"
                    disabled={disabledTakeDevice}
                    onClick={(e) => handleClick(setVisibleOpenAdminTakeDevice, e)}
                >
                    <IconButton
                        color={'warning'}
                        disableRipple
                        style={{
                            padding: 0,
                            margin: 0,
                        }}
                        disabled={disabledTakeDevice}
                    >
                        <Iconify color="warning" icon="mdi:tray-arrow-up" />
                        <Typography sx={{ ml: 1 }}>{t('take_device')}</Typography>
                    </IconButton>
                </MenuItem>,

                <Divider key="divider1" sx={{ my: 0.5 }} />,

                // Bước 2: Xác nhận (chỉ hiện khi đã lấy thiết bị)
                <MenuItem
                    key="approve"
                    disabled={disabledApproveReject}
                    onClick={(e) => handleClick(setVisibleOpenChecking, e)}
                >
                    <IconButton
                        color={'success'}
                        disableRipple
                        style={{
                            padding: 0,
                            margin: 0,
                        }}
                        disabled={disabledApproveReject}
                    >
                        <Iconify color="success" icon="line-md:check-all" />
                        <Typography sx={{ ml: 1 }}>{t('comfirm')}</Typography>
                    </IconButton>
                </MenuItem>,

                <Divider key="divider2" sx={{ my: 0.5 }} />,

                // Bước 2: Từ chối (chỉ hiện khi đã lấy thiết bị, không cần bỏ lại)
                <MenuItem key="reject" disabled={disabledReject} onClick={(e) => handleClick(setVisibleReject, e)}>
                    <IconButton
                        color={'error'}
                        disableRipple
                        style={{
                            padding: 0,
                            margin: 0,
                        }}
                        disabled={disabledReject}
                    >
                        <Iconify color="error" icon="mdi:cancel" />
                        <Typography sx={{ ml: 1 }}>{t('reject')}</Typography>
                    </IconButton>
                </MenuItem>,

                // Bỏ thiết bị vào lại (chỉ hiện khi đã lấy ra và chưa từ chối)
                !hasNotTakenDevice && item.status !== '4' && <Divider key="divider3" sx={{ my: 0.5 }} />,

                !hasNotTakenDevice && item.status !== '4' && (
                    <MenuItem
                        key="put-device"
                        disabled={disabledPutDevice}
                        onClick={(e) => handleClick(setVisibleOpenAdminPutDevice, e)}
                    >
                        <IconButton disabled={disabledPutDevice} color="warning" disableRipple sx={{ p: 0, m: 0 }}>
                            <Iconify icon="mdi:tray-arrow-down" color="warning" />
                            <Typography sx={{ ml: 1 }}>{t('input_device')}</Typography>
                        </IconButton>
                    </MenuItem>
                ),
            ]}
        </Menu>
    );
};

export default MenuActionsItem;
